exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".custom-select{line-height:21px;height:30px;border-radius:5px}.custom-select-sm{height:30px!important;line-height:13px;padding-top:0;padding-bottom:0;padding-left:12px}", ""]);

// exports
